import Tooltip from 'lib/src/components/tooltip/Tooltip';
import React from 'react';

interface Props {
    index: number;
}

const AssessmentTooltip = ({ index }: Props) => {
    return (
        <Tooltip content={assessmentTooltips[index]} position="top right">
            <span className="assessment-tooltip-i">i</span>
        </Tooltip>
    );
};

const assessmentTooltips = [
    <span className="assessment-tooltip-content">
        <sub>
            <b>1 -</b> Greater than 4 years
        </sub>
        <sub>
            <b>2 -</b> 3 to 4 years
        </sub>
        <sub>
            <b>3 -</b> 2 to 3 years
        </sub>
        <sub>
            <b>4 -</b> 1 to 2 years
        </sub>
        <sub>
            <b>5 -</b> Less than 1 year
        </sub>
    </span>,
    <span className="assessment-tooltip-content">
        <sub>
            <b>1 -</b> Out of scope
        </sub>
        <sub>
            <b>2 -</b> Attempts to answer scope but lacks applicability
        </sub>
        <sub>
            <b>3 -</b> Fits part of the challenge scope
        </sub>
        <sub>
            <b>4 -</b> Fits challenge scope with room for minor improvement
        </sub>
        <sub>
            <b>5 -</b> Answers challenge scope absolutely
        </sub>
    </span>,
    <span className="assessment-tooltip-content">
        <sub>
            <b>1 -</b> Company requires further investigation.
        </sub>
        <sub>
            <b>2 -</b> Company needs review
        </sub>
        <sub>
            <b>3 -</b> Company shows promise
        </sub>
        <sub>
            <b>4 -</b> Company has good structure
        </sub>
        <sub>
            <b>5 -</b> Company is credible
        </sub>
    </span>,
    <span className="assessment-tooltip-content">
        <sub>
            <b>1 -</b> Technology proposed is an unrealistic solution
        </sub>
        <sub>
            <b>2 -</b> Technology needs a review
        </sub>
        <sub>
            <b>3 -</b> Technology shows promise
        </sub>
        <sub>
            <b>4 -</b> Technology demonstrated in other non-related sectors
        </sub>
        <sub>
            <b>5 -</b> Technology demonstrated within a related sector
        </sub>
    </span>,
    <span className="assessment-tooltip-content">
        <sub>
            <b>1 -</b> Needs to review solution.
        </sub>
        <sub>
            <b>2 -</b> Needs lead partner/OEM to lead
        </sub>
        <sub>
            <b>3 -</b> Needs JV partner
        </sub>
        <sub>
            <b>4 -</b> Needs supporting technology
        </sub>
        <sub>
            <b>5 -</b> Turn key
        </sub>
    </span>,
];

export default AssessmentTooltip;
